export const colorTokens = {
  // Primary
  'blue': '#4165ff',
  'blue-lighter': '#607AFF',
  'blue-light': '#5466F9',
  'blue-light-hover': '#4B5FEA',
  'blue-dark': '#3645bb',
  'blue-dark-hover': '#3041a8',

  // Supporting
  'mauve': '#d9beff',
  'green-money-in': '#008375',

  // Monochromes
  'white': '#ffffff',
  'off-white': '#f9f9fb',
  'off-white-dark': '#F2F2F7',
  'pearl-grey': '#efeffd',
  'pearl-grey-medium': '#e4e5fc',
  'pearl-grey-dark': '#d8d8e9',
  'pearl-grey-darker': '#cacadd',
  'pearl-grey-darkest': '#9d9db0',
  'grey': '#71718E',
  'grey-medium': '#565674',
  'grey-dark': '#41415A',
  'black': '#1F1F30',

  // Supplementary Colors
  'green-light': '#c0ffee',
  'green': '#0ad19f',
  'green-dark': '#004f49',
  'red-light': '#FBE5F0',
  'red-dark': '#C5046C',
  'red': '#D9177E',

  // Table/Dropdown Highlight colors
  'highlight': '#eaf3fe',
  'highlight-dark': '#cce3fc',
  'highlight-darker': '#aac7f8',

  // Hover colors
  'pearl-grey-hover': '#e4e5fc',
  'off-white-hover': '#efeffd',

  // Poker table coloring
  'poker-green': '#35654d',
  'poker-green-darker': '#1b3428',
  'poker-green-lighter': '#1e4532',
  'poker-green-darkest': '#1A2B22',
}

export type ColorName = keyof typeof colorTokens
